"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function EToP(isChosen) {
    return function (externalName) {
        var nameSet = { chosen: "UNDEF", notChosen: "undef" };
        switch (externalName.toUpperCase()) {
            case "Growth":
                nameSet = { chosen: "GROWTH", notChosen: "RPGROWTH" };
            case "Highgrowth":
            case "Aggressive":
                nameSet = { chosen: "HIGHGROWTH", notChosen: "RPHIGHGROWTH" };
            case "Balanced":
                nameSet = { chosen: "BALANCED", notChosen: "RPBALANCED" };
            case "Moderate":
                nameSet = { chosen: "MODERATE", notChosen: "RPMODERATE" };
            case "User Defined":
                nameSet = { chosen: "USERDEFINEDALLOCATION", notChosen: "USERDEFINEDALLOCATION" };
        }
        return isChosen ? nameSet.chosen : nameSet.notChosen;
    };
}
exports.EToP = EToP;
function PToE(isSS) {
    return function (protoName) {
        switch (protoName.toUpperCase()) {
            case "RPGROWTH":
            case "GROWTH":
                return "Growth";
            case "RPHIGHGROWTH":
            case "HIGHGROWTH":
                return isSS ? "High Growth" : "Aggressive";
            case "RPBALANCED":
            case "BALANCED":
                return "Balanced";
            case "RPMODERATE":
            case "MODERATE":
                return "Moderate";
            case "USERDEFINEDALLOCATION":
                return "User Defined";
        }
        return "undefined";
    };
}
exports.PToE = PToE;
//# sourceMappingURL=ProtobufferAndExternalNameConversion.js.map